// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1ff3f729ed17ecee18f8","678":"a691c0eff484972c3146","883":"5a3ca37055dad04b2c1d"}[chunkId] + ".js";
};